export default __webpack_public_path__ + "locales/lo-LA/Common.json?hash=b073608ea2712774e591fb78dfb6524e";